export const features = [
  {
    id: 'feature-1',
    icon: 'ri-shield-star-line',
    title: '0 鎖號保證',
    description: '來源 100% 合法，非黑卡非刷退卡，絕不使用非法點數，帳號安全有保障',
    color: 'from-emerald-500 to-teal-500'
  },
  {
    id: 'feature-2',
    icon: 'ri-timer-flash-line',
    title: '10 分鐘速儲',
    description: '專業操作人員待命，確認付款後最快 10 分鐘完成儲值，效率業界第一',
    color: 'from-amber-500 to-orange-500'
  },
  {
    id: 'feature-3',
    icon: 'ri-percent-line',
    title: '全站自動 9 折',
    description: '無需領券、無需輸入折扣碼，全站下單即享 9 折優惠，省錢最輕鬆',
    color: 'from-rose-500 to-pink-500'
  },
  {
    id: 'feature-4',
    icon: 'ri-lock-password-line',
    title: 'SSL 全程加密',
    description: '全站 HTTPS 加密傳輸，帳號資料閱後即焚，24 小時後自動遮蔽，安全無虞',
    color: 'from-slate-600 to-gray-700'
  }
];
